class StretchModal extends HTMLElement {
  constructor() {
    super()
    this.opened = false

    // Bind once so we can add/remove listeners reliably
    this._onEsc = this._onEsc.bind(this)
    this._onOpenClick = this._onOpenClick.bind(this)
    this._onOpenKey = this._onOpenKey.bind(this)
    this._onCloseClick = this._onCloseClick.bind(this)
  }

  connectedCallback() {
    // Query AFTER the element is connected so children exist
    this.modalOpenBtn = this.querySelector('[data-info-icon]')
    this.modalContainer = this.querySelector('[data-info-modal]')
    this.modalCloseBtn = this.querySelector('[data-info-close]')
    this.modal = this.querySelector('.stretch__modal')
    this.modalTitle = this.querySelector('.stretch__modal .stretch__title')

    if (!this.modalOpenBtn || !this.modalContainer || !this.modalCloseBtn) {
      console.warn('[stretch-modal] Missing required elements inside <stretch-modal>')
      return
    }

    // Wire events
    this.modalOpenBtn.addEventListener('click', this._onOpenClick)
    this.modalOpenBtn.addEventListener('keydown', this._onOpenKey) // keyboard open
    this.modalCloseBtn.addEventListener('click', this._onCloseClick)
  }

  disconnectedCallback() {
    // Clean up
    this.modalOpenBtn?.removeEventListener('click', this._onOpenClick)
    this.modalOpenBtn?.removeEventListener('keydown', this._onOpenKey)
    this.modalCloseBtn?.removeEventListener('click', this._onCloseClick)
    document.removeEventListener('keydown', this._onEsc, true)
  }

  _onOpenClick(e) {
    e.preventDefault()
    this.stretchModalOpen()
  }

  _onOpenKey(e) {
    // Enter or Space should open
    if ((e.key === 'Enter' || e.key === ' ') && !this.opened) {
      e.preventDefault()
      this.stretchModalOpen()
    }
  }

  _onCloseClick(e) {
    e.preventDefault()
    this.stretchModalClose()
  }

  _onEsc(e) {
    const isEsc = e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27
    if (!this.opened || !isEsc) return
    e.preventDefault()
    e.stopPropagation()
    this.stretchModalClose()
  }

  stretchModalOpen() {
    // Toggle the wrapper (your CSS targets .stretch__modal-wrapper--open on [data-info-modal])
    this.modalContainer.classList.add('stretch__modal-wrapper--open')
    if (this.modal && typeof trapFocus === 'function') trapFocus(this.modal)
    if (this.modalTitle) this.modalTitle.focus()
    this.opened = true

    // Add Esc while open; capture = true so it wins over other handlers
    document.addEventListener('keydown', this._onEsc, true)
  }

  stretchModalClose() {
    this.modalContainer.classList.remove('stretch__modal-wrapper--open')
    this.opened = false
    if (typeof removeTrapFocus === 'function') removeTrapFocus()
    // Return focus to trigger
    this.modalOpenBtn?.focus()
    document.removeEventListener('keydown', this._onEsc, true)
  }
}

customElements.define('stretch-modal', StretchModal)
